var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import CatalogLocalNavigation from './CatalogLocalNavigation';
import TvLocalNavigation from './TvLocalNavigation';
import NewsLocalNavigation from './NewsLocalNavigation';
import style from './NavigationHeader.module.scss';
import { useAperzaUserContext } from '../AperzaUserContext';
import AppConfig from '../../utils/AppConfig';
var getTvLocalNavigation = function (onTop) {
    var _a;
    return (_jsx("div", __assign({ className: clsx(style.localNavHeader, (_a = {}, _a[style.onScroll] = !onTop, _a)) }, { children: _jsx("div", __assign({ className: style.navbar }, { children: _jsx(TvLocalNavigation, {}) })) })));
};
var getCatalogLocalNavigation = function (onTop) {
    var _a;
    return (_jsx("div", __assign({ className: clsx(style.localNavHeader, (_a = {}, _a[style.onScroll] = !onTop, _a)) }, { children: _jsx("div", __assign({ className: style.navbar }, { children: _jsx(CatalogLocalNavigation, {}) })) })));
};
var getNewsLocalNavigation = function (onTop) {
    var _a;
    return (_jsx("div", __assign({ className: clsx(style.localNavHeader, (_a = {}, _a[style.onScroll] = !onTop, _a)) }, { children: _jsx("div", __assign({ className: style.navbar }, { children: _jsx(NewsLocalNavigation, {}) })) })));
};
export default function LocalNavigationHeader(_a) {
    var fixed = _a.fixed;
    var serviceType = useAperzaUserContext().serviceType;
    var _b = useState(true), onTop = _b[0], setOnTop = _b[1];
    var scrollCheck = useCallback(function () {
        var posY = window.scrollY;
        if (posY > 0 && onTop) {
            setOnTop(false);
        }
        if (posY === 0 && !onTop) {
            setOnTop(true);
        }
    }, [onTop]);
    useEffect(function () {
        if (fixed) {
            document.addEventListener('scroll', scrollCheck);
            return function () {
                document.removeEventListener('scroll', scrollCheck);
            };
        }
        return function () { };
    }, [scrollCheck, fixed]);
    switch (serviceType) {
        case AppConfig.APERZA_TV:
            return getTvLocalNavigation(onTop);
        case AppConfig.APERZA_CATALOG:
            return getCatalogLocalNavigation(onTop);
        case AppConfig.APERZA_NEWS:
            return getNewsLocalNavigation(onTop);
        default:
            return _jsx(_Fragment, {});
    }
}
